import { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";
import { METRICS } from "./data";
import { Container, MaskText, Reveal, Overline } from "./primitives";

const Counter = ({ to, suffix }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: 0.3 });
  const [v, setV] = useState(to);
  useEffect(() => {
    if (!inView) return undefined;
    const c = animate(0, to, { duration: 2, ease: [0.16, 1, 0.3, 1], onUpdate: (x) => setV(Math.round(x)) });
    return () => c.stop();
  }, [inView, to]);
  return <span ref={ref}>{v}{suffix}</span>;
};

export const Metrics = () => (
  <section className="bg-white py-20 lg:py-32" data-testid="metrics-section">
    <Container>
      <Overline>Maturidade</Overline>
      <MaskText className="font-display mt-6 max-w-3xl text-3xl font-bold leading-[1.05] tracking-[-0.03em] text-[#0F172A] sm:text-5xl"
        lines={["Métricas consolidadas", <>de atuação e <span className="text-[#1238CE]">maturidade.</span></>]} />
      <div className="mt-14 grid border-t border-slate-200 md:grid-cols-3">
        {METRICS.map((m, i) => (
          <Reveal key={m.l} delay={i * 0.1} className={`py-10 md:px-8 ${i ? "border-t border-slate-200 md:border-l md:border-t-0" : "md:pl-0"}`}>
            <div className="font-display text-7xl font-extrabold tracking-[-0.05em] text-[#0F172A] lg:text-8xl" data-testid={`metric-value-${i}`}>
              <Counter to={m.n} suffix={m.s} />
            </div>
            <div className="mt-4 text-base font-bold text-[#0F172A]">{m.l}</div>
            <p className="mt-2 max-w-xs text-sm leading-relaxed text-slate-600">{m.d}</p>
          </Reveal>
        ))}
      </div>
    </Container>
  </section>
);
